import { render, staticRenderFns } from "./appItemFake.vue?vue&type=template&id=d9ed488e&scoped=true"
import script from "./appItemFake.vue?vue&type=script&lang=js"
export * from "./appItemFake.vue?vue&type=script&lang=js"
import style0 from "./appItemFake.vue?vue&type=style&index=0&id=d9ed488e&prod&lang=scss&scoped=true"
import style1 from "./appItemFake.vue?vue&type=style&index=1&id=d9ed488e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ed488e",
  null
  
)

export default component.exports